import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * AppSpinner - Microcomponente de indicador de carregamento
 * Substitui mat-spinner com um spinner baseado em CSS puro
 *
 * @example
 * <app-spinner [size]="40" [color]="'primary'" />
 */
@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="spinner"
      [style.width.px]="size"
      [style.height.px]="size"
      [ngClass]="colorClass"
    >
      <div class="spinner-inner"></div>
    </div>
  `,
  styles: [
    `
      .spinner {
        display: inline-block;
        position: relative;
      }
      .spinner-inner {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid transparent;
        animation: spin 1.2s linear infinite;
      }
      .primary .spinner-inner {
        border-top-color: #1976d2;
        border-left-color: #1976d2;
      }
      .accent .spinner-inner {
        border-top-color: #ff4081;
        border-left-color: #ff4081;
      }
      .warn .spinner-inner {
        border-top-color: #f44336;
        border-left-color: #f44336;
      }
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class AppSpinnerComponent {
  @Input() size: number = 40;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';

  get colorClass(): string {
    return this.color || 'primary';
  }
}
